define.alias("ember-composable-helpers/helpers/pick", "calendar/helpers/pick");